import React from "react";
import { Container } from "react-bootstrap";
import useTerms from "hooks/useTerms";
import parse from 'html-react-parser';


const TermsSection = () => {
  const { termsData } = useTerms();
  return (
    <section className="terms-page">
      <Container>
        <div className="terms-container">
          {parse(termsData?.description || "")}
        </div>
      </Container>
    </section>
  );
};

export default TermsSection;
